import getScenarioStore from '../store/getScenarioStore';
import { SearchScenarioId } from 'owa-search-next-common';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('onSearchInputClicked', (scenarioId: SearchScenarioId) => {
    getScenarioStore(scenarioId).isSuggestionsDropdownVisible = true;
});
